import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Form dialogs that track unsaved changes must not auto-close on router
 * NavigationStart. Otherwise browser Back closes the dialog, clears dirty
 * state in ngOnDestroy, and canDeactivate never shows the confirm prompt.
 */
export const UNSAVED_FORM_DIALOG_OPTIONS: Pick<
  MatDialogConfig,
  'closeOnNavigation'
> = {
  closeOnNavigation: false,
};
